import * as gs from "@ivanlog/gs";
import { CmpRangeBase } from "./tmpls";

export class CmpRange extends CmpRangeBase {

    private _isDragging=false;
    private _spans:gs.WrapperGS[]=[];

    private _onChangeValue:gs.EventGS<number>;
    private _onChangeValueToken:gs.EventGSToken<number>;

    private _value:number=0;
    constructor() {
        super();
        this._onChangeValueToken = new gs.EventGSToken<number>();
        this._onChangeValue = new gs.EventGS(this._onChangeValueToken);
        const mouseMoveHandler = (e)=>{
            if (!this._isDragging) return;
            this._updateByClientX(e.clientX);
        }
        const mouseUpHandler = (e)=>{
            this._isDragging = false;
            window.removeEventListener('mousemove', mouseMoveHandler);
            window.removeEventListener('mouseup', mouseUpHandler);
        }
        const mouseStartHandler = (e)=>{
            this._isDragging = true;
            gs.events.stop(e);
            this._updateByClientX(e.clientX)
            window.addEventListener('mousemove', mouseMoveHandler);
            window.addEventListener('mouseup', mouseUpHandler);
        }
        this.ctrls.range.el.addEventListener('mousedown', mouseStartHandler);
        this.ctrls.cursor.el.addEventListener('mousedown', mouseStartHandler);

        const touchMoveHandler = (e)=>{
            if (!this._isDragging) return;
            this._updateByClientX(e.touches[0].clientX);
        }
        const touchEndHandler = (e)=>{
            this._isDragging = false;
            window.removeEventListener('touchmove', touchMoveHandler);
            window.removeEventListener('touchend', touchEndHandler);
        }
        const touchStartHandler = (e)=>{
            this._isDragging = true;
            gs.events.stop(e);
            this._updateByClientX(e.touches[0].clientX)
            window.addEventListener('touchmove', touchMoveHandler);
            window.addEventListener('touchend', touchEndHandler);
        }
        this.ctrls.range.el.addEventListener('touchstart', touchStartHandler);
        this.ctrls.cursor.el.addEventListener('touchstart', touchStartHandler); 

        for(let i=1;i<10;i++)
        {
            const s = gs.w(gs.html.span());
            s.el.style.left=(i*10)+"%";
            this.ctrls.range.prepend(s)           
            this._spans.push(s); 
        }
        const _value = this.attr('value');
        if (_value) this.value = parseInt(_value);
    }

    public get onChangeValue() {return this._onChangeValue;}

    public draw(){
        this._drawValue();
    }

    public get value() {return this._value;}
    public set value(value:number) {
        value = Math.trunc(value); 
        if(value>100) value=100; 
        this._value = value; 
        this._drawValue();
    }

    _updateByClientX(clientX: number) {
        const rect = this.ctrls.range.el.getBoundingClientRect();
        const percent = (clientX - rect.left) / rect.width;
        this._value = Math.trunc(Math.max(0, Math.min(1, percent))* 100)
        this._drawValue();
        this.el.dispatchEvent(new Event("input"));
        this._onChangeValueToken.invoke(this._value);
    };

    _drawValue()
    {
        this.ctrls.background.el.style.width = `${this._value}%`;
        this.ctrls.cursor.el.style.left = `${this._value}%`;
        this.ctrls.cursor.el.style.transform = `translateX(-${this._value}%)`;
        for(let i=1;i<10;i++)
        {
            if (this._value<i*10) this._spans[i-1].inactive();
            else this._spans[i-1].active();
        }
        this.ctrls.lValue.text = this._value+"%";
    }
}
